module.exports = __webpack_public_path__ + "static/img/slide_1_fr.edac75f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_1_fr.svg
// module id = IJ4s
// module chunks = 0